/* tslint:disable */
/* eslint-disable */
/**
 * Real Estate CRM Web API
 * API endpoints for web application
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { DelayedPaymentsResultDto } from '../models';
// @ts-ignore
import { UpcomingPaymentsResultDto } from '../models';
/**
 * PaymentsApi - axios parameter creator
 * @export
 */
export const PaymentsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {number} [projectId] 
         * @param {number} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentsDelayedGet: async (pageNumber?: number, pageSize?: number, searchTerm?: string, projectId?: number, clientId?: number, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Payments/delayed`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (pageNumber !== undefined) {
                localVarQueryParameter['PageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['PageSize'] = pageSize;
            }

            if (searchTerm !== undefined) {
                localVarQueryParameter['SearchTerm'] = searchTerm;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['ProjectId'] = projectId;
            }

            if (clientId !== undefined) {
                localVarQueryParameter['ClientId'] = clientId;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @param {string} [to] 
         * @param {string} [from] 
         * @param {number} [projectId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentsUpcomingGet: async (to?: string, from?: string, projectId?: number, pageNumber?: number, pageSize?: number, search?: string, sort?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/Payments/upcoming`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication Bearer required
            await setApiKeyToObject(localVarHeaderParameter, "Authorization", configuration)

            if (to !== undefined) {
                localVarQueryParameter['to'] = (to as any instanceof Date) ?
                    (to as any).toISOString() :
                    to;
            }

            if (from !== undefined) {
                localVarQueryParameter['from'] = (from as any instanceof Date) ?
                    (from as any).toISOString() :
                    from;
            }

            if (projectId !== undefined) {
                localVarQueryParameter['projectId'] = projectId;
            }

            if (pageNumber !== undefined) {
                localVarQueryParameter['pageNumber'] = pageNumber;
            }

            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }

            if (sort !== undefined) {
                localVarQueryParameter['sort'] = sort;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PaymentsApi - functional programming interface
 * @export
 */
export const PaymentsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PaymentsApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {number} [projectId] 
         * @param {number} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentsDelayedGet(pageNumber?: number, pageSize?: number, searchTerm?: string, projectId?: number, clientId?: number, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<DelayedPaymentsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentsDelayedGet(pageNumber, pageSize, searchTerm, projectId, clientId, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @param {string} [to] 
         * @param {string} [from] 
         * @param {number} [projectId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async apiPaymentsUpcomingGet(to?: string, from?: string, projectId?: number, pageNumber?: number, pageSize?: number, search?: string, sort?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<UpcomingPaymentsResultDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.apiPaymentsUpcomingGet(to, from, projectId, pageNumber, pageSize, search, sort, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * PaymentsApi - factory interface
 * @export
 */
export const PaymentsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PaymentsApiFp(configuration)
    return {
        /**
         * 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [searchTerm] 
         * @param {number} [projectId] 
         * @param {number} [clientId] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentsDelayedGet(pageNumber?: number, pageSize?: number, searchTerm?: string, projectId?: number, clientId?: number, options?: any): AxiosPromise<DelayedPaymentsResultDto> {
            return localVarFp.apiPaymentsDelayedGet(pageNumber, pageSize, searchTerm, projectId, clientId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @param {string} [to] 
         * @param {string} [from] 
         * @param {number} [projectId] 
         * @param {number} [pageNumber] 
         * @param {number} [pageSize] 
         * @param {string} [search] 
         * @param {string} [sort] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        apiPaymentsUpcomingGet(to?: string, from?: string, projectId?: number, pageNumber?: number, pageSize?: number, search?: string, sort?: string, options?: any): AxiosPromise<UpcomingPaymentsResultDto> {
            return localVarFp.apiPaymentsUpcomingGet(to, from, projectId, pageNumber, pageSize, search, sort, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * Request parameters for apiPaymentsDelayedGet operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiPaymentsDelayedGetRequest
 */
export interface PaymentsApiApiPaymentsDelayedGetRequest {
    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiPaymentsDelayedGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiPaymentsDelayedGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiPaymentsDelayedGet
     */
    readonly searchTerm?: string

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiPaymentsDelayedGet
     */
    readonly projectId?: number

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiPaymentsDelayedGet
     */
    readonly clientId?: number
}

/**
 * Request parameters for apiPaymentsUpcomingGet operation in PaymentsApi.
 * @export
 * @interface PaymentsApiApiPaymentsUpcomingGetRequest
 */
export interface PaymentsApiApiPaymentsUpcomingGetRequest {
    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiPaymentsUpcomingGet
     */
    readonly to?: string

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiPaymentsUpcomingGet
     */
    readonly from?: string

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiPaymentsUpcomingGet
     */
    readonly projectId?: number

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiPaymentsUpcomingGet
     */
    readonly pageNumber?: number

    /**
     * 
     * @type {number}
     * @memberof PaymentsApiApiPaymentsUpcomingGet
     */
    readonly pageSize?: number

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiPaymentsUpcomingGet
     */
    readonly search?: string

    /**
     * 
     * @type {string}
     * @memberof PaymentsApiApiPaymentsUpcomingGet
     */
    readonly sort?: string
}

/**
 * PaymentsApi - object-oriented interface
 * @export
 * @class PaymentsApi
 * @extends {BaseAPI}
 */
export class PaymentsApi extends BaseAPI {
    /**
     * 
     * @param {PaymentsApiApiPaymentsDelayedGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public apiPaymentsDelayedGet(requestParameters: PaymentsApiApiPaymentsDelayedGetRequest = {}, options?: AxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).apiPaymentsDelayedGet(requestParameters.pageNumber, requestParameters.pageSize, requestParameters.searchTerm, requestParameters.projectId, requestParameters.clientId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @param {PaymentsApiApiPaymentsUpcomingGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PaymentsApi
     */
    public apiPaymentsUpcomingGet(requestParameters: PaymentsApiApiPaymentsUpcomingGetRequest = {}, options?: AxiosRequestConfig) {
        return PaymentsApiFp(this.configuration).apiPaymentsUpcomingGet(requestParameters.to, requestParameters.from, requestParameters.projectId, requestParameters.pageNumber, requestParameters.pageSize, requestParameters.search, requestParameters.sort, options).then((request) => request(this.axios, this.basePath));
    }
}
